import { createSlice } from "@reduxjs/toolkit";
import {
  fetchChequeList,
  updateChequeStatus,
  updateChequeExpectedBank,
  fetchChequeCustomersBySearch,
  fetchChequeAccounts,
  fetchChequeById,
  deleteCheque,
} from "./chequesThunk";

const initialState = {
  list: [],
  customers: [],
  accounts: [],
  selected: null,
  customersLoading: false,
  accountsLoading: false,
  loading: false,
  filters: {
    type: "all",
    from_acc_id: null,
  },
    successMessage: null,
};

const chequesSlice = createSlice({
  name: "cheques",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChequeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChequeList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchChequeList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateChequeStatus.fulfilled, (state, action) => {
        // No direct row update — list will refresh from fetchChequeList
      })
      .addCase(updateChequeExpectedBank.fulfilled, (state, action) => {
        // No direct row update — list will refresh from fetchChequeList
      })
      .addCase(fetchChequeCustomersBySearch.pending, (state) => {
        state.customersLoading = true;
      })
      .addCase(fetchChequeCustomersBySearch.fulfilled, (state, action) => {
        state.customersLoading = false;
        state.customers = action.payload;
      })
      .addCase(fetchChequeCustomersBySearch.rejected, (state) => {
        state.customersLoading = false;
        state.customers = [];
      })
      .addCase(fetchChequeAccounts.pending, (state) => {
        state.accountsLoading = true;
      })
      .addCase(fetchChequeAccounts.fulfilled, (state, action) => {
        state.accountsLoading = false;
        state.accounts = action.payload;
      })
      .addCase(fetchChequeAccounts.rejected, (state) => {
        state.accountsLoading = false;
        state.accounts = [];
      })
      .addCase(fetchChequeById.fulfilled, (state, action) => {
        state.selected = action.payload;
      })
      .addCase(deleteCheque.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { setFilters } = chequesSlice.actions;
export default chequesSlice.reducer;
